// extracted by mini-css-extract-plugin
module.exports = {"attribution":"_2KRBkdJbh_SNvS_8Sn6mcu"};